import { Col } from 'antd';
import React from 'react';
import ArticleHeroSkeleton from './ArticleHeroSkeleton';

type Props = {
  halfColumn?: boolean,
};
const defaultProps = {
  halfColumn: false,
};

const ArticleLoadingSkeletonBundle = function ArticleLoadingSkeletonBundle(props: Props) {
  const { halfColumn } = props;
  return (
    <>
      {[1, 2, 3, 4, 5, 6, 7].map(() => (
        <Col
          span={12}
          xs={24}
          sm={halfColumn ? 12 : 24}
          md={12}
          className="article-grid"
        >
          <ArticleHeroSkeleton articleHeight="389px" />
        </Col>
      ))}
    </>
  );
};

ArticleLoadingSkeletonBundle.defaultProps = defaultProps;
export default ArticleLoadingSkeletonBundle;
